import { render, staticRenderFns } from "./Muti.vue?vue&type=template&id=a638b9d4&scoped=true"
import script from "./Muti.vue?vue&type=script&lang=js"
export * from "./Muti.vue?vue&type=script&lang=js"
import style0 from "./Muti.vue?vue&type=style&index=0&id=a638b9d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a638b9d4",
  null
  
)

export default component.exports